import { FieldViewModel, IOmniaShell, shell } from "../../omnia"
import { ISoilService } from "../../types"
import { SoilAnalysisVM } from "./soil-vm"

/// <reference path="soil-vm.ts" />

export class AvgAnalysisCmd {

    static create(svc: ISoilService, field: FieldViewModel, analysis: SoilAnalysisVM[], shell: IOmniaShell, refreshHandler: Function) {

        if (analysis.some(a => a.analysis.CalculatedAverage)) {
            return null;
        }

        let zones = analysis.filter(a => a.isZonal());

        if (!zones.length) {
            return null;
        }

        let layerId = zones[0].layer.DataLayerId;

        let cmd = new AvgAnalysisCmd(svc, field, layerId, shell, refreshHandler);

        return cmd;

    }

    constructor(
        private svc: ISoilService,
        private field: FieldViewModel,
        private layerId: number,
        private shell: IOmniaShell,
        private refreshHandler: Function) {

    }

    public execute() {

        shell.showYesNo(this.shell, "You are about to generate an average soil analysis based on the analysis of its zones, for the field " + this.field.description + ".<br/>Are you sure to generate this soil analysis ?",
            "Soil analysis generation").then(r => {
                if (r) {
                    this.svc.generateSoilAnalysis([
                        {
                            fieldId: this.field.fieldId,
                            datalayerId: this.layerId
                        }]).then(r => this.refreshHandler());
                }
            });

    }

}
